var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLossArrow1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5998 31.7418L27.9876 9.62018L14.7912 17.3599C14.6273 17.4569 14.4342 17.493 14.2462 17.462C14.0581 17.431 13.887 17.3348 13.7631 17.1904L0 1.04918L1.23058 0L14.5565 15.6247L27.7285 7.90114C27.8874 7.80771 28.0736 7.77118 28.2561 7.7976C28.4387 7.82402 28.6067 7.9118 28.7324 8.04641L49.7818 30.6442L48.5998 31.7418Z",
    fill: "#FB2C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1903 32H44.3328V30.3859H48.3807V26.3506H49.9999V31.193C49.9999 31.407 49.9146 31.6123 49.7628 31.7636C49.611 31.915 49.405 32 49.1903 32Z",
    fill: "#FB2C36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossArrow1);
export default __webpack_public_path__ + "static/media/lossArrow1.0719ab1c47bf3174bb2bbf066c1f1b67.svg";
export { ForwardRef as ReactComponent };